(function() {
    'use strict';
    angular
        .module('c3WebApp')
        .factory('TaskSupervisor', TaskSupervisor);

    TaskSupervisor.$inject = ['$resource'];

    function TaskSupervisor ($resource) {
        var resourceUrl =  'api/certificate-request-batches/:id/pendant/supervisor';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    

})();
